import styled from 'styled-components';

export const CommonCategoryCarouselStyled = styled.div`
  background: ${(props) => (props.bgColor ? `${props.bgColor} !important` : props.theme.sectionBox.bodyBg)};
  .ePharmacy {
    .link {
      color: ${(props) => props?.theme?.green?.dark};

      &:hover {
        color: ${(props) => props?.theme?.green?.light};
      }
    }
  }
  .container {
    padding: ${(props) => !props?.title && !props?.viewAll ? '28px 0 0 0' : !props?.title && props?.viewAll? '16px 0 0 0' : '4px'};
  }
  .homeCare {
    .link {
      color: ${(props) => props?.theme?.blue?.royal};

      &:hover {
        color: ${(props) => props?.theme?.blue?.light};
      }
    }
    
    .categoryItemBox {
      &.newDesign {
        .item {
          .img {
            border: 1px solid ${(props) => props?.theme?.royalBlue?.lightGrey};
          }
        }
      }
    }
  }
  .slick-slider {
    margin-bottom: 20px;

    .slick-list {
      width: 100%;
      margin: 0;
    }
    .slick-slide {
      width: auto !important;
    }
    .slick-next {
      right: 5px !important;
      top:  ${(props) => (props.title || props.viewAll ? '54px' : '35%')} !important;
    }
    .slick-prev {
      top: ${(props) => (props.title || props.viewAll ? '54px' : '35%')} !important;
      z-index: 1;
    }
  }

  .categoryItemBox {
    width: 100%;
    cursor: pointer;
    color: inherit;
    text-decoration: inherit;
    display: flex;

    .item {
      width: 100%;
      margin: 0 7px 0 8px;
      padding: 24px 16px;
      background: ${(props) => props?.theme?.color?.white};
      border: 1px solid ${(props) => props?.theme?.grey?.iconBg};
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .img {
      width: 108px;
      height: 108px;
      margin: 0 0 8px 0;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        position: relative !important;

        > img {
          width: 100% !important;
          height: 100% !important;
          max-width: 133px !important;
          max-height: 103px !important;
          /* position: relative !important;
          min-width: 80px !important; */
        }
      }
    }
    .name {
      width: 90%;
      padding-bottom: 0px;
      height: 42px;
      font-size: 14px;
      line-height: 21px;
      font-weight: 600;
      text-align: center;
      word-wrap: break-word;
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    &.newDesign {
      .item {
        background: transparent;
        border: 0;
        padding: 0;

        .img {
          width: 100px;
          height: 100px;
          border: 1px solid ${(props) => props?.theme?.green?.medium};
          margin-bottom: 16px;
          > div {
            border-radius: 50%;
          }
        }
      }
    }
  }

  .slider-item:last-child {
    margin-right: 16px; 
  }

  @media (max-width: 820px) {
    padding: 0 0 5px 0;

    .container {
      padding: 16px 0;
    }

    .slick-slider {
      margin: 0;

      .slick-slide {
        width: 17.5vw !important;
      }
    }
  }

  @media (max-width: 767px) {
    .flex-ItemBox-wrap{
      flex-wrap: wrap;
      gap: 20px;

      .categoryItemBox {
        &.newDesign {
          &.large{
            width: calc(25% - 15px);

            .item {
              width: 100%;

              .img {
                width: 84px;
                height: 84px;
              }
            }
          }
        }
     }
   }
  }

  @media (max-width: 572px) {
    .flex-ItemBox-wrap {
      gap: 0px;
    }
    .container {
      padding: 0 8px;
      .categoryItemBox {
        &.newDesign {
          .item {
          width: 18vw;
            .img {
              height: 20vw;
              width: 20vw;
            }
          }
          &.large {
            width: 22%;
          }
        }
      }
    }
    .slick-slider {
      .slick-next {
        top:  ${(props) => (props.title || props.viewAll ? '10vw' : 'calc(10vw + 20px)')} !important;
      }
      .slick-prev {
        top: ${(props) => (props.title || props.viewAll ? '10vw' : 'calc(10vw + 20px)')} !important;
      }
    }      
  }

 
  @media (max-width: 480px) {
    .flex-ItemBox-wrap{
      gap: 0px;
    }
    .slick-slider {
      .slick-slide {
        width: 30vw !important;
      }
    }
    .sectionBox {
      padding-left: 0;
      padding-right: 0;

      .slick-track {
        margin-left: 32px;
      }

      .container {
        padding-bottom: 0px;
        .titleBar {
          padding-left: 16px;
          padding-right: 16px;
        }

        .slick-arrow {
          &.slick-prev {
            left: 0;
            top: 39px !important;
          }
          &.slick-next {
            right: 0;
            top: 39px !important;
          }
        }
      }
    }
    .categoryItemBox {
      width: calc(100% - 12px);
      margin: 0 6px 10px 6px;
      box-sizing: border-box;
      .item {
        width: 100%;
        margin: 0;
        box-sizing: border-box;
      }
      .name {
        margin-bottom: 16px;
    }
  }
  .gridContainer {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-left: 6px;
    padding: ${(props) => (props.title || props.viewAll ? '0 0 10px 0' : !props.title && !props.viewAll ? '20px 0 0 0' : '0')};

    @media (max-width: 480px) {
      gap: 0 12px;
    }
  }

  .slick-slider {
    margin: 0 -8px 0 -8px;
  }
`;
